var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-headphone-mono",
    clipPath: "url(#clip0_2690_41170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4412 10.6882C17.4412 8.99248 16.2712 7.57648 14.7 7.17298V6.67498C14.7 3.53173 12.1432 0.974976 8.99997 0.974976C5.85747 0.974976 3.30072 3.53173 3.30072 6.67498V7.17298C1.72872 7.57648 0.558716 8.99248 0.558716 10.6882C0.559709 11.6538 0.943761 12.5795 1.62657 13.2621C2.30939 13.9448 3.23517 14.3287 4.20072 14.3295C4.43941 14.3295 4.66833 14.2347 4.83711 14.0659C5.00589 13.8971 5.10072 13.6682 5.10072 13.4295V6.67498C5.10072 4.52472 6.84972 2.77498 8.99997 2.77498C11.1502 2.77498 12.9 4.52472 12.9 6.67498V13.0567L10.995 14.9617C10.9116 15.0454 10.8125 15.1118 10.7033 15.157C10.5941 15.2021 10.4771 15.2253 10.359 15.225H8.91672C8.67802 15.225 8.4491 15.3198 8.28032 15.4886C8.11154 15.6574 8.01672 15.8863 8.01672 16.125C8.01672 16.3637 8.11154 16.5926 8.28032 16.7614C8.4491 16.9302 8.67802 17.025 8.91672 17.025H10.359C11.0805 17.025 11.7585 16.7445 12.2685 16.2345L14.2147 14.2875C16.0252 14.079 17.4412 12.5542 17.4412 10.6882Z",
    fill: "#8B95A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2690_41170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHeadphone);
export default __webpack_public_path__ + "static/media/icon_menu_headphone.a5d2a7687a744c200e6dfa3beacb85ba.svg";
export { ForwardRef as ReactComponent };